import { getSiteProps } from "../utils/siteProps";

// const SEEKER_PROFILE = "/home";
const SEEKER_PROFILE = "/seeker-profile";
const CAREER_SERVICES = "/career-services";

const SEEKER_PROFILE_API_PATH = `${SEEKER_PROFILE}/api`;
const CAREER_SERVICES_API_PATH = `${CAREER_SERVICES}/api`;

export const getBuildEnvVar = (url?: string | null) => {
  // rfs prod qa1
  try {
    if (!url || /local/.test(url)) {
      return "qa1";
    } else {
      const env = url.split(".")[0];
      return env === "www" ? "prod" : env;
    }
  } catch (e) {
    return "qa1";
  }
};

export const getRecaptchaSiteKey = (host: string | null) => {
  return getBuildEnvVar(host) === "prod"
    ? "6LeZIWUrAAAAABfFKQpT9l4iQjDzOlsko28e6Udl"
    : "6Lf0G2UrAAAAAIerLP7SUUqeTkmhluBqEmsak3cV";
};

export const API_ENDPOINT = (host?: string) => {
  //! NOTE:
  //! WINDOW IS USED BECAUSE OF WE KNOW THAT THIS FILE IS USED IN CLIENT SIDE
  //! IF WE USE THIS FILE IN SERVER SIDE THEN WE NEED TO PASS HOSTNAME AS PARAMETER
  const hostname =
    host ||
    (window && window.location && window.location.hostname
      ? window.location.hostname
      : "");
  const siteProps = getSiteProps(hostname);
  // const env: string = getRuntimeVariables(hostname || "");
  const apiUrl = siteProps?.api_url;
  // const domain = siteProps?.domain;
  // const siteMap = siteProps?.site_map;

  return {
    seekerProfile: {
      masterDataMiddleware: `${apiUrl}${SEEKER_PROFILE_API_PATH}/getMasterData`,
      validateProfileMiddleware: `${apiUrl}${SEEKER_PROFILE_API_PATH}/validateProfile`,
      workExperienceMiddleware: `${apiUrl}${SEEKER_PROFILE_API_PATH}/workExperience`,
      employmentDetailsMiddleware: `${apiUrl}${SEEKER_PROFILE_API_PATH}/employmentDetails`,
      employmentDetailsProfileNudge: `${apiUrl}${SEEKER_PROFILE_API_PATH}/employmentDetailsProfileNudge`,
      jobPreferencesMiddleware: `${apiUrl}${SEEKER_PROFILE_API_PATH}/jobPreferences`,
      educationDetailsMiddleware: `${apiUrl}${SEEKER_PROFILE_API_PATH}/educationDetails`,
      sendOTPMiddleware: `${apiUrl}${SEEKER_PROFILE_API_PATH}/getMobileOTP`,
      verifyOTPMiddleware: `${apiUrl}${SEEKER_PROFILE_API_PATH}/verifyMobileOTP`,
      sendEmailOTPMiddleware: `${apiUrl}${SEEKER_PROFILE_API_PATH}/getEmailOTP`,
      verifyEmailOTPMiddleware: `${apiUrl}${SEEKER_PROFILE_API_PATH}/verifyEmailOTP`,
      profileDetails: `${apiUrl}${SEEKER_PROFILE_API_PATH}/profileDetails`,
      sitePropsMiddleware: `${apiUrl}${SEEKER_PROFILE_API_PATH}/getSiteProps`,
      splash: `${apiUrl}${SEEKER_PROFILE_API_PATH}/splash`,
      updateEmploymentDetailsMiddleware: `${apiUrl}${SEEKER_PROFILE_API_PATH}/updateEmploymentDetails`,
      attachResume: `${apiUrl}${SEEKER_PROFILE_API_PATH}/attachResume`,
      nextNudge: `${apiUrl}${SEEKER_PROFILE_API_PATH}/nextNudge`,
      updateResumeEmployment: `${apiUrl}${SEEKER_PROFILE_API_PATH}/updateResumeEmployment`,
      lgbtqDisability: `${apiUrl}${SEEKER_PROFILE_API_PATH}/lgbtqDisability`,
      getEmploymentDetailsMiddleware: `${apiUrl}${SEEKER_PROFILE_API_PATH}/profileDetails?fields=employments`,
      updateSalary: `${apiUrl}${SEEKER_PROFILE_API_PATH}/updateSalary`,
    },
    cms: {
      banner: `${apiUrl}${CAREER_SERVICES_API_PATH}/cmsBanner`,
    },
  };
};
